// Bleeds a sticky bar over the Courses/Classrooms screen root's horizontal
// padding so list items don't show in the gutters as they scroll under it.
// Keep in sync with the `root` padding in CoursesScreen/ClassroomsScreen.
// Left/right longhands only, so callers can still set vertical spacing.
const bleed = (theme, amount) => ({
  marginLeft: theme.spacing(-amount),
  marginRight: theme.spacing(-amount),
  paddingLeft: theme.spacing(amount),
  paddingRight: theme.spacing(amount),
});

export default function stickyBarBleed(theme) {
  return {
    ...bleed(theme, 2),
    [theme.breakpoints.up("sm")]: bleed(theme, 3),
  };
}
